import { createApi } from "@reduxjs/toolkit/query/react";

import apiConfig from "configs/apiConfig";
import { REDUCER_PATHS } from "store/config";
import { transformResponseHandler } from "utils/transformResponseHandler";

import { customFetchBase } from ".";

const fourvenuesAPI = createApi({
  reducerPath: REDUCER_PATHS.FOURVENUES,
  baseQuery: customFetchBase,

  endpoints: (builder) => ({
    getOrgList: builder.mutation({
      query: () => ({
        url: apiConfig.FOURVENUES_ORG_LIST,
        method: "GET",
      }),
      transformResponse: (resp) => transformResponseHandler(resp, false),
    }),
  }),
});

export const { useGetOrgListMutation } = fourvenuesAPI;

export default fourvenuesAPI;
